var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "star_svg__icon",
    viewBox: "0 0 1024 1024",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M987.429 369.714q0 12.572-14.858 27.429L765.143 599.429l49.143 285.714q.571 4 .571 11.428 0 12-6 20.286t-17.428 8.286q-10.858 0-22.858-6.857L512 783.429 255.429 918.286q-12.572 6.857-22.858 6.857-12 0-18-8.286t-6-20.286q0-3.428 1.143-11.428l49.143-285.714-208-202.286q-14.286-15.429-14.286-27.429 0-21.143 32-26.285l286.858-41.715L484 41.714q10.857-23.428 28-23.428t28 23.428l128.571 260L955.43 343.43q32 5.142 32 26.285z",
    fill: "#00B67A"
  })));
};
export default SvgStar;